import { QueryResult, gql } from "@outschool/ui-apollo";
import { usePaginatedQuery } from "@outschool/ui-components-website";

import {
  TextFeedbackByUserQuery,
  TextFeedbackByUserQueryVariables,
} from "../../shared/generated/graphql";

const textFeedbackByUserQuery = gql`
  query TextFeedbackByUser($userUid: ID!, $offset: Int) {
    textFeedbackByUser(userUid: $userUid, offset: $offset) {
      uid
      details {
        publicReview
      }
      activity_star_rating
      created_at
      activity {
        uid
        isClub
        slug_id
        title
        titleTranslated
      }
    }
  }
`;

export type PublicTextFeedbackByParentQueryOptions = {
  variables: TextFeedbackByUserQueryVariables;
};

const getItems = (result: TextFeedbackByUserQuery) => result.textFeedbackByUser;

const getResult = (
  previousResult: TextFeedbackByUserQuery,
  fetchMoreResult: TextFeedbackByUserQuery,
): TextFeedbackByUserQuery => {
  return {
    textFeedbackByUser: [
      ...previousResult.textFeedbackByUser,
      ...fetchMoreResult.textFeedbackByUser,
    ],
  };
};

const getFetchMoreVariables = (
  result: QueryResult<
    TextFeedbackByUserQuery,
    TextFeedbackByUserQueryVariables
  >,
): Partial<TextFeedbackByUserQueryVariables> => ({
  offset: result.data?.textFeedbackByUser.length,
});

export const usePublicReviewsByParentQuery = (
  options: PublicTextFeedbackByParentQueryOptions,
) => {
  const {
    data,
    loading,
    error,
    fetchMore: fetchMorePublicReviewsByParent,
    isFetchingMore,
    hasMore,
  } = usePaginatedQuery(
    textFeedbackByUserQuery,
    options,
    getItems,
    getResult,
    getFetchMoreVariables,
  );

  return {
    data,
    loading,
    error,
    fetchMorePublicReviewsByParent,
    isFetchingMore,
    hasMore,
  };
};
